<!-- HEADER -->
<div
  #header
  class="header-area mat-elevation-z6"
  [ngClass]="{
    'background-white': sharedService.kidsCat$ | async
  }"
>
  <div *ngIf="layoutService.layoutSettings$ | async as layoutSettings" id="header" class="no-print">
    <ng-container *ngIf="(sharedService.kidsCat$ | async) === false; else kidsCatHeader">
      <mat-toolbar
        #origin="matAutocompleteOrigin"
        id="header-mobile"
        class="d-flex d-lg-none"
        matAutocompleteOrigin
      >
        <mat-toolbar-row>
          <div fxLayout="row" fxFlex="100" fxLayoutGap="10px" fxLayoutAlign="start center">
            <!-- SideNav Toggle -->
            <button
              mat-icon-button
              aria-label="Toggle Navigation"
              type="button"
              (click)="toggleSideNav()"
            >
              <mat-icon>menu</mat-icon>
            </button>
            <!-- Logo Brand -->
            <ag-logo-title
              class="d-none d-md-flex"
              [settings]="{ layoutSettings, libraryName: userData.libraryName }"
            ></ag-logo-title>
            <div fxLayout="row" fxFlex="100" fxLayoutGap="10px">
              <!-- Search Input -->
              <div
                #overlayOrigin="cdkOverlayOrigin"
                class="search-input"
                fxLayout="row"
                fxLayoutAlign="start stretch"
                cdkOverlayOrigin
              >
                <div fxFlex fxLayoutAlign="stretch center">
                  <input
                    style="width: 100%; margin-left: 10px"
                    type="text"
                    autocomplete="off"
                    placeholder="Search..."
                    [formControl]="searchTerm"
                    [matAutocomplete]="searchAutocomplete"
                    [matAutocompleteConnectedTo]="origin"
                    (keydown.enter)="searchEnter()"
                  />
                  <button
                    *ngIf="searchTerm.value?.length >= 1"
                    mat-icon-button
                    aria-label="Clear Search"
                    matTooltip="Clear Search"
                    type="button"
                    (click)="clearInput()"
                  >
                    <mat-icon>close</mat-icon>
                  </button>
                  <mat-autocomplete
                    #searchAutocomplete="matAutocomplete"
                    class="header-mobile-autocomplete-panel"
                  >
                    <div
                      *ngIf="searchSuggestions.length > 1"
                      fxLayout="row"
                      class="sticky-top bg-white"
                    >
                      <button
                        *ngFor="let item of searchSuggestions; let i = index"
                        mat-button
                        type="button"
                        (click)="scrollToOption('select-option-' + i)"
                      >
                        {{ item.heading }}
                      </button>
                    </div>
                    <div *ngIf="searchSuggestions.length">
                      <div *ngFor="let item of searchSuggestions; let i = index">
                        <mat-optgroup [label]="item.heading" [id]="'select-option-' + i">
                          <mat-option
                            *ngFor="let value of item.results"
                            style="white-space: pre"
                            [innerHTML]="value.termHtml"
                            [value]="value.searchTerm"
                            (onSelectionChange)="selectSearchOption($event, value)"
                          >
                          </mat-option>
                        </mat-optgroup>
                      </div>
                    </div>
                  </mat-autocomplete>
                </div>
                <div fxLayout="row" fxFlex="nogrow">
                  <button
                    mat-icon-button
                    aria-label="Search"
                    type="button"
                    [disabled]="!enableSearch || !resources.length || !indexesArray?.length"
                    (click)="searchEnter()"
                  >
                    <mat-icon>search</mat-icon>
                  </button>
                  <ng-container *ngIf="showSearchOptions">
                    <!-- TBD Search Options -->
                    <mat-divider [vertical]="true"></mat-divider>
                    <button
                      mat-icon-button
                      aria-label="Search Options"
                      type="button"
                      (click)="isSearchOptionsOpen = !isSearchOptionsOpen"
                    >
                      <mat-icon>arrow_drop_down</mat-icon>
                    </button>
                  </ng-container>
                </div>
              </div>

              <ng-template
                cdkConnectedOverlay
                [cdkConnectedOverlayOrigin]="overlayOrigin"
                [cdkConnectedOverlayOpen]="isSearchOptionsOpen"
                [cdkConnectedOverlayHasBackdrop]="true"
                [cdkConnectedOverlayPositions]="[
                  {
                    originX: 'center',
                    originY: 'bottom',
                    overlayX: 'center',
                    overlayY: 'top'
                  },
                  {
                    originX: 'center',
                    originY: 'top',
                    overlayX: 'center',
                    overlayY: 'top'
                  }
                ]"
                (backdropClick)="isSearchOptionsOpen = false"
              >
                <div>
                  <mat-card appearance="outlined">
                    <mat-card-content>
                      <div fxLayout="column">
                        <mat-form-field fxFlex="100">
                          <mat-label>Search Index</mat-label>
                          <mat-select>
                            <mat-option
                              *ngFor="let index of indexesArray; let i = index"
                              [value]="index"
                              (click)="mobileSelectIndex(index)"
                            >
                              {{ index.name }}</mat-option
                            >
                          </mat-select>
                        </mat-form-field>
                      </div>

                      <mat-expansion-panel [hideToggle]="false">
                        <mat-expansion-panel-header>
                          <mat-panel-title>Resources</mat-panel-title>
                          <mat-panel-description
                            >Libraries and Digital sources.</mat-panel-description
                          >
                        </mat-expansion-panel-header>
                        resource 1
                      </mat-expansion-panel>
                    </mat-card-content>
                    <mat-card-actions align="end">
                      <button mat-button type="button">Reset</button>
                      <button mat-button type="button">Done</button>
                    </mat-card-actions>
                  </mat-card>
                </div>
              </ng-template>
            </div>
            <ng-container>
              <div>
                <!-- Guest / Patron -->
                <ng-container *ngIf="userData.isGuest; else user">
                  <button mat-button type="button" (click)="goToLogin()">
                    {{ layoutSettings.loginButtonText }}
                  </button>
                </ng-container>
                <ng-template #user>
                  <!-- Conditional mat button types; text / icon-->
                  <button
                    fxHide.lt-md
                    mat-button
                    type="button"
                    (click)="openSideNavMenu('end', '')"
                  >
                    {{ userData.firstName }}
                    <mat-icon *ngIf="!avatar; else profileImage">account_circle</mat-icon>
                    <ng-template #profileImage>
                      <img alt="Profile Image" [src]="avatar" />
                    </ng-template>
                    <!-- User Account -->
                  </button>
                  <button
                    mat-icon-button
                    type="button"
                    aria-label="More options"
                    matTooltip="More"
                    [matMenuTriggerFor]="accountMenu"
                    fxHide
                    fxShow.lt-md
                  >
                    <mat-icon *ngIf="!avatar; else profileImage">account_circle</mat-icon>
                    <ng-template #profileImage>
                      <img alt="Profile Image" [src]="avatar" />
                    </ng-template>
                    <!-- User Account -->
                  </button>
                  <mat-menu #accountMenu="matMenu">
                    <button
                      mat-menu-item
                      type="button"
                      (click)="routingService.goToAccountProfile()"
                    >
                      Edit Profile
                    </button>
                    <button mat-menu-item type="button" (click)="authService.OnLogOut()">
                      Logout
                    </button>
                  </mat-menu>
                </ng-template>
              </div>
            </ng-container>
          </div>
        </mat-toolbar-row>
        <mat-toolbar-row fxHide.gt-md fxHide.lt-sm fxLayoutAlign="start start">
          <div fxFlex="nogrow">
            <a
              *ngIf="menuItems && menuItems[0] as menuItem"
              mat-icon-button
              tabindex="0"
              [attr.aria-label]="menuItem.label"
              [matTooltip]="menuItem.icon ? menuItem.label : ''"
              (agInteract)="handleMenuNavigation(menuItem)"
            >
              <ng-container *ngIf="menuItem.label">
                {{ menuItem.label }}
              </ng-container>
              <i *ngIf="menuItem.icon" aria-hidden="true" [class]="menuItem.icon"></i>
            </a>
          </div>
          <!-- overflow needed to enable scrollable content -->
          <div fxFlex="auto" style="overflow-x: hidden">
            <ag-scroll-area [verticalScroll]="false">
              <ng-container *ngFor="let menuItem of menuItems; let i = index">
                <a
                  *ngIf="i > 0"
                  mat-button
                  tabindex="0"
                  [attr.aria-label]="menuItem.label"
                  [matTooltip]="menuItem.icon ? menuItem.label : ''"
                  (agInteract)="handleMenuNavigation(menuItem)"
                >
                  <ng-container *ngIf="menuItem.label"> {{ menuItem.label }} </ng-container>
                  <i *ngIf="menuItem.icon" aria-hidden="true" [class]="menuItem.icon"></i>
                </a>
              </ng-container>
            </ag-scroll-area>
          </div>
          <div fxFlex="nogrow">
            <ng-container *ngIf="showRightActions">
              <button
                mat-icon-button
                matTooltip="Kids Category"
                type="button"
                (click)="routingService.goToKidsCat()"
              >
                <i class="fa fa-lg ag-kids">
                  <img
                    class="ag-kids-filling"
                    title="Kids Catalog"
                    src="./assets/icons/KidsCatalog/kids-icon-fill.png"
                    alt="Kids Catalog"
                  />
                </i>
              </button>
              <button
                *ngIf="layoutSettings.showLanguages"
                mat-icon-button
                matTooltip="Select Language"
                type="button"
              >
                <mat-icon>translate</mat-icon>
              </button>
            </ng-container>
          </div>
        </mat-toolbar-row>
      </mat-toolbar>
      <!-- Desktop -->
      <div *ngIf="(sharedService.kidsCat$ | async) === false" id="header-desktop">
        <div class="row d-none d-lg-flex">
          <div class="col-lg-3 align-self-center">
            <ag-logo-title
              [settings]="{ layoutSettings, libraryName: userData.libraryName }"
            ></ag-logo-title>
          </div>
          <div class="col-lg-6">
            <div fxLayout="row" id="quick-search">
              <div *ngIf="layoutSettings.showLanguages" class="qs-translate-container">
                <div class="qs-translate">
                  <div
                    id="google_translate_element"
                    class="google-lang-dropdown"
                    title="Select Language"
                  ></div>
                  <div class="translator-globe">
                    <div>
                      <i
                        class="fa fa-language translator lang-icon"
                        title="Select Language"
                        aria-hidden="true"
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
              <div fxFlex="nogrow">
                <div class="qs-index-container">
                  <!-- Select Indexes -->
                  <div
                    class="qs-index"
                    [hidden]="indexesArray === null"
                    [class]="selectSearchIndexHasFocus ? 'focused' : ''"
                  >
                    <select
                      tabindex="0"
                      title="Select Search Index"
                      aria-label="Select Index"
                      class="headeritem-no-outline"
                      [title]="'Search Indexed by ' + $safeNavigationMigration(selectedIndex?.name)"
                      [ngModel]="selectedIndex"
                      [disabled]="!showIndexSelection"
                      (focus)="selectSearchIndexHasFocus = true"
                      (blur)="selectSearchIndexHasFocus = false"
                      (ngModelChange)="onChangeSearchIndex($event)"
                    >
                      <option
                        *ngFor="let index of indexesArray; let i = index"
                        [selected]="index.isDefault"
                        [ngValue]="index"
                        [attr.selected]="i === 0 ? true : null"
                      >
                        {{ index.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div *ngIf="showResourceSelection" fxFlex="nogrow">
                <div class="qs-resource-container">
                  <!-- Select Resources -->
                  <div
                    class="nav-search-resources qs-resource"
                    [class]="showResourceHasFocus ? 'focused' : ''"
                    tabindex="0"
                    aria-label="Select Resources"
                    matTooltip="Select Resources"
                    (focus)="showResourceHasFocus = true"
                    (blur)="showResourceHasFocus = false"
                    (agInteract)="openSideNavMenu('start', 'resources')"
                  >
                    <i class="fa fa-database" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
              <div
                fxLayout="row"
                fxFlex="grow"
                class="qs-input-container"
                [class]="searchInputHasFocus ? 'focused' : ''"
              >
                <div fxFlex="grow">
                  <form>
                    <div class="qs-search-input">
                      <input
                        #searchInput
                        id="searchInput"
                        matInput
                        autocomplete="off"
                        spellcheck="true"
                        aria-hidden="false"
                        tabindex="0"
                        aria-label="Search Term"
                        role="combobox"
                        class="deleteicon bg-white search-field"
                        aria-expanded="false"
                        aria-controls="header-autocomplete-panel"
                        [attr.title]="'search word by : ' + selectedIndex.name"
                        [formControl]="searchTerm"
                        [matAutocomplete]="auto"
                        (focus)="searchInputHasFocus = true"
                        (blur)="searchInputHasFocus = false"
                        (keydown.enter)="searchEnter()"
                      />
                      <mat-autocomplete
                        #auto="matAutocomplete"
                        id="header-autocomplete-panel"
                        class="header-autocomplete-panel dense"
                      >
                        <div *ngIf="searchSuggestions.length">
                          <div *ngFor="let item of searchSuggestions">
                            <h5>{{ item.heading }}</h5>
                            <mat-option
                              *ngFor="let value of item.results"
                              class="nav-fill__mat-option"
                              [value]="value.searchTerm"
                              (onSelectionChange)="selectSearchOption($event, value)"
                            >
                              <span [innerHTML]="value.termHtml"></span>
                            </mat-option>
                          </div>
                        </div>
                      </mat-autocomplete>
                    </div>
                  </form>
                </div>
                <div fxLayout="row" fxLayoutAlign="start strech" class="qs-actions-container">
                  <div
                    *ngIf="searchTerm.value?.length >= 1"
                    fxFlex
                    fxLayoutAlign="center center"
                    class="clear-button"
                    tabindex="0"
                    role="button"
                    aria-label="Clear Search"
                    matTooltip="Clear Search"
                    (agInteract)="clearInput()"
                  >
                    <i class="fa fa-times" aria-hidden="true"></i>
                  </div>
                  <div class="action-divider"></div>
                  <div
                    fxFlex
                    fxLayoutAlign="center center"
                    matTooltip="Search"
                    class="search-button"
                    role="button"
                    [tabindex]="
                      !enableSearch || !resources.length || !indexesArray?.length ? -1 : 0
                    "
                    [attr.aria-label]="'Search the term : ' + searchInput.value"
                    [ngClass]="{
                      'greyed-out': !enableSearch || !resources.length || !indexesArray?.length
                    }"
                    (agInteract)="doSearch(searchTerm.value, null)"
                  >
                    <i class="fa fa-search" aria-hidden="true"> </i>
                  </div>
                </div>
              </div>
              <div class="qs-advanced-container" fxLayoutAlign="center stretch">
                <div
                  tabindex="0"
                  aria-label="Advanced Search"
                  class="qs-advanced pointer"
                  [class]="searchAdvancedHasFocus ? 'focused' : ''"
                  (blur)="searchAdvancedHasFocus = false"
                  (focus)="searchAdvancedHasFocus = true"
                  (agInteract)="goToAdvancedSearch()"
                >
                  <div>Advanced</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 notify-icons">
            <div class="top-deck">
              <a
                *ngIf="userData?.enableKidsCat"
                class="icon-badge kids-catalog"
                aria-label="Kids Catalog"
                tabindex="0"
                matTooltip="Kids Catalog"
                (agInteract)="routingService.goToKidsCat()"
              >
                <i class="fa ag-kids fa-lg" aria-hidden="true">
                  <img
                    class="ag-kids-filling"
                    src="./assets/icons/KidsCatalog/kids-icon-fill.png"
                    alt="kids catalog"
                  />
                </i>
              </a>
              <a
                *ngIf="showBrowseIndexes"
                class="icon-badge"
                tabindex="0"
                matTooltip="Browse Search"
                aria-label="Browse Search"
                (agInteract)="goToBrowseSearch()"
              >
                <i class="fa ag-browse-search fa-lg" aria-hidden="true"> </i>
              </a>
            </div>
            <div fxLayout="row" fxLayoutAlign="end none">
              <span>
                <!-- guest ill tracking icon -->
                <a
                  *ngIf="showGuestTracking && userData?.systemCategory === SYSTEM_CATEGORY.SHAREIT"
                  class="icon-badge"
                  tabindex="0"
                  aria-label="Guest ILL Tracking"
                  matTooltip="Guest ILL Tracking"
                  (agInteract)="guestTrack()"
                >
                  <i class="fa fa-xlg fa-list-ol fa-lg" aria-hidden="true"></i>
                </a>
                <!-- MY LIST -->
                <a
                  *ngIf="showList"
                  class="icon-badge"
                  tabindex="0"
                  aria-label="Your List"
                  matTooltip="Your List"
                  title="Your List"
                  (agInteract)="goToYourList()"
                >
                  <i class="fa fa-list-alt fa-lg" aria-hidden="true"></i>
                  <span *ngIf="yourSharedListCount > 0" class="badge-share-count">{{
                    yourSharedListCount
                  }}</span>
                  <span *ngIf="yourListCount > 0" class="badge badge-pill badge-default">{{
                    yourListCount
                  }}</span>
                </a>
              </span>
              <span *ngIf="!userData.isGuest">
                <!-- QUICK MENU -->
                <a
                  *ngIf="quickMenu && userData?.isStaff"
                  class="icon-badge"
                  aria-label="Quick Links"
                  matTooltip="Quick Links"
                  tabindex="0"
                  (agInteract)="openSideNavMenu('end', 'quickmenu')"
                >
                  <i class="fa fa-heart fa-lg fa-lg" aria-hidden="true"></i>
                  <span class="badge badge-pill badge-default">F9</span>
                </a>
                <!-- NOTIFICATIONS -->
                <a
                  *ngIf="!userData.isGuest"
                  class="icon-badge"
                  aria-label="Notifications"
                  matTooltip="Notifications"
                  tabindex="0"
                  (agInteract)="openSideNavMenu('end', 'notify')"
                >
                  <i class="fa fa-bell-o fa-lg fa-lg" aria-hidden="true"></i>
                  <ng-container *ngIf="unreadMessageCount$ | async">
                    <!-- 62902 - Message Alert System: Alarm bell not display alert 'number of messages' when there is a new message -->
                    <span
                      class="badge badge-pill badge-default"
                      [ngClass]="{
                        red: (unreadMessageCount$ | async) > 0
                      }"
                      >{{ unreadMessageCount$ | async }}</span
                    >
                  </ng-container>
                </a>
              </span>
            </div>
          </div>
        </div>
        <div class="row d-none d-lg-flex">
          <div class="header-links x-scroll-bar scrollbar" style="padding-top: 1px" id="style-4">
            <a
              *ngFor="let menuItem of menuItems; let i = index"
              class="header-link active-header-link pointer"
              tabindex="0"
              [attr.aria-label]="menuItem.label"
              [matTooltip]="menuItem.icon ? menuItem.label : ''"
              (agInteract)="handleMenuNavigation(menuItem)"
            >
              <ng-container *ngIf="menuItem.label">
                {{ menuItem.label }}
              </ng-container>
              <i *ngIf="menuItem.icon" aria-hidden="true" [class]="menuItem.icon"></i>
            </a>
          </div>
          <div class="header-options">
            <span *ngIf="!userData.isGuest" class="stacked-text">
              <div
                class="stacked-top truncate-ellipsis d-block"
                title="Hello, {{ userData.firstName }}"
              >
                Hello, {{ userData.firstName }}
              </div>
              @if (userData.customerId?.toUpperCase() !== 'DILS1') {
                <a
                  class="stacked-bottom"
                  tabindex="0"
                  style="font-size: 1em !important"
                  (agInteract)="openSideNavMenu('end', '')"
                  >Your Account<i class="fa fa-angle-down" aria-hidden="true"></i>
                </a>
              }
            </span>
            <a
              *ngIf="userData.isGuest"
              class="non-stacked-text"
              tabindex="0"
              style="font-size: 1em !important"
              (agInteract)="goToLogin()"
            >
              {{ layoutSettings.loginButtonText }}
            </a>
            <a
              *ngIf="!userData.isGuest"
              tabindex="0"
              class="non-stacked-text"
              (agInteract)="authService.OnLogOut()"
              ><span class="single-row">Logout</span>
            </a>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #kidsCatHeader>
      <!-- Mobile -->
      <div class="d-flex d-md-none">
        <div class="logo-brand padding-15-0 text-center" style="width: 100%">
          <button
            class="btn btn-link d-inline transparent pull-right action-buttons-kids-mobile"
            type="button"
            (click)="exitKC()"
          >
            Exit
          </button>
          <button
            class="btn btn-link d-inline transparent pull-right action-buttons-kids-mobile"
            type="button"
            (click)="aboutMeKC()"
          >
            About Me
          </button>
          <h4
            style="cursor: pointer"
            class="kids-cat-logo-mobile pull-right"
            tabindex="0"
            (agInteract)="routingService.goToKidsCat()"
          >
            Kids
          </h4>
          <button
            *ngIf="!userData.isGuest"
            class="btn btn-link d-inline transparent action-buttons-kids-mobile"
            type="button"
            (click)="goToLogin()"
          >
            Logout
          </button>
          <button
            *ngIf="userData.isGuest"
            class="btn btn-link d-inline transparent action-buttons-kids-mobile"
            type="button"
            (click)="goToLogin()"
          >
            {{ layoutSettings.loginButtonText }}
          </button>
        </div>
      </div>
      <!-- Tablet -->
      <div class="d-none d-md-block d-lg-none">
        <div class="col-sm-12">
          <button
            class="btn btn-link d-inline transparent pull-right margin-top-2-percent"
            type="button"
            (click)="exitKC()"
          >
            Exit
          </button>
          <button
            class="btn btn-link d-inline transparent pull-right margin-top-2-percent"
            type="button"
            (click)="aboutMeKC()"
          >
            About Me
          </button>
          <button
            *ngIf="userData.isGuest"
            class="btn btn-link d-inline transparent pull-right margin-top-2-percent"
            type="button"
            (click)="goToLogin()"
          >
            {{ layoutSettings.loginButtonText }}
          </button>
          <button
            *ngIf="!userData.isGuest"
            class="btn btn-link d-inline transparent pull-right margin-top-2-percent"
            type="button"
            (click)="goToLogin()"
          >
            Logout
          </button>
          <h4
            class="kids-cat-logo-tablet d-inline transparent pull-right"
            style="margin-right: 10%; cursor: pointer"
            tabindex="0"
            (agInteract)="routingService.goToKidsCat()"
          >
            Kids
          </h4>
        </div>
      </div>

      <!-- Desktop -->
      <div class="container-fluid" style="margin-top: 20px">
        <div class="row d-none d-lg-flex">
          <div class="col-12 col-md-9" style="text-align: center">
            <img
              src="./assets/images/kids-catalog/logo.gif"
              alt="Logo"
              title="logo"
              style="margin-top: -20px; max-height: 100px; margin-left: 30%"
              tabindex="0"
              (agInteract)="routingService.goToKidsCat()"
            />
            <img
              src="./assets/images/kids-catalog/kids-title.gif"
              alt="Kids Catalog"
              title="Kids Catalog"
              style="cursor: pointer"
              tabindex="0"
              (agInteract)="routingService.goToKidsCat()"
            />
          </div>
          <div class="col-12 col-md-3 text-end">
            <img
              *ngIf="userData.isGuest"
              alt="Login"
              src="./assets/images/kids-catalog/login.png"
              style="margin-right: 5px"
              title="Login"
              style="cursor: pointer"
              tabindex="0"
              (agInteract)="goToLogin()"
            />
            <img
              *ngIf="!userData.isGuest"
              alt="Log Out"
              src="./assets/images/kids-catalog/Logout.png"
              style="margin-right: 5px"
              title="Logout"
              style="cursor: pointer"
              tabindex="0"
              (agInteract)="authService.OnLogOut()"
            />
            <img
              *ngIf="!userData.isGuest"
              alt="About Me"
              src="./assets/images/kids-catalog/aboutme.gif"
              style="margin-right: 5px"
              title="About Me"
              style="cursor: pointer"
              tabindex="0"
              (agInteract)="aboutMeKC()"
            />
            <img
              alt="Exit"
              src="./assets/images/kids-catalog/exit.gif"
              style="margin-right: 5px"
              title="Exit"
              style="cursor: pointer"
              tabindex="0"
              (agInteract)="exitKC()"
            />
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
